/**
 * Route for `automation-crud-permission-scope`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AutomationCrudPermissionScopePage } from "../features/automation-crud-permission-scope/AutomationCrudPermissionScopePage";

export const automationCrudPermissionScopeRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/automation-crud-permission-scope",
	component: AutomationCrudPermissionScopePage,
});

export default automationCrudPermissionScopeRoute;
